'use client';

import animationData from '@/animations/logo.json';
import { css } from '@onbeam/business-styled-system/css';
import dynamic from 'next/dynamic';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const MissionLogo = () => (
  <div className={css({ w: '[2.5rem]', h: '[2.5rem]' })}>
    <Lottie animationData={animationData} autoplay={true} loop={false} />
  </div>
);
